<template>
  <div class="customRqb-wrap">
    <div class="table-wrap">
      <div class="page-header">
        <div class="header-line">
          <el-select style="width: 160px" v-model="filterData.zt">
            <el-option label="全部主体" :value="-1"> </el-option>
          </el-select>
        </div>
        <div class="header-line" style="margin-top: 16px">
          <el-button
            class="btn"
            type="primary"
            icon="el-icon-refresh"
            @click="synchronization"
            >同步</el-button
          >
          <el-button class="btn btn-outline">
            <svg-icon iconClass="pl" className="pl-icon"></svg-icon
            >批量删除</el-button
          >
          <el-input
            placeholder="请输入内容"
            suffix-icon="el-icon-search"
            v-model="filterData.searchStr"
            style="width: 160px; margin-left: auto"
          >
          </el-input>
        </div>
      </div>
      <el-table :data="[{}]" style="width: 100%" height="calc(100vh - 200px)">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="date" label="人群包名称"> </el-table-column>
        <el-table-column prop="date" label="人群包ID"> </el-table-column>
        <el-table-column prop="date" label="所属主体"> </el-table-column>
        <el-table-column prop="date" label="关联账户数"> </el-table-column>
        <el-table-column prop="date" label="上传人数"> </el-table-column>
        <el-table-column prop="date" label="覆盖人数"> </el-table-column>
        <el-table-column label="操作" width="100">
          <template>
            <el-button type="text" size="small" @click="push">推送</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <push-modal ref="pushModalRef"></push-modal>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import PushModal from "./sub/push.vue";
export default {
  name: "CustomPkg",
  components: {
    SvgIcon,
    PushModal,
  },
  data() {
    return {
      filterData: {
        zt: -1,
        searchStr: "",
      },
    };
  },
  methods: {
    synchronization() {
      this.$message({
        message: "同步中，请稍后刷新列表",
        iconClass: "el-icon-refresh",
        customClass: "sync-class",
      });
    },
    push() {
      this.$refs.pushModalRef.showTransferModal();
    },
  },
};
</script>

<style lang="less" scoped>
.customRqb-wrap {
  padding: 16px;
  .table-wrap {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .page-header {
      margin-bottom: 16px;
      .header-line {
        display: flex;
        .btn {
          height: 32px;
          &.btn-outline {
            color: rgba(24, 144, 255, 1);
            border-radius: 2px;
            border: 1px solid rgba(24, 144, 255, 1);
          }
          .pl-icon {
            margin-right: 4px;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.sync-class {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.25);
  min-width: 220px;
  padding: 10px 16px;
  .el-icon-refresh {
    color: rgba(24, 144, 255, 1);
    margin-right: 6px;
  }
}
</style>